import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  TextField,
} from "@material-ui/core";
import withWidth from "@material-ui/core/withWidth";
import { withStyles } from "@material-ui/styles";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";

import CustomizedDialogs from "../../../components/FormDialog/FormDialog";
import { confirm } from "../../../components/ConfirmationDialog/ConfirmationDialog";
import { confirmable, createConfirmation } from "react-confirm";
import CategoryStore from "../../../Store/CategoryStore";

const styles = (theme) => ({
  header: {
    textAlign: "center",
  },
  textField: {
    color: "#FFFFFF",
    width: "100%",
  },
  section: {
    color: "#8a8888",
    width: "100%",
    background: "#c1c1c1",
    padding: "5px",
  },
});

function Form(props) {
  const { classes, width, data, cancel } = props;
  const [openDialog, setOpenDialog] = React.useState(true);
  const [componentWillMount] = React.useState(false);
  const [, categoryActions] = CategoryStore();

  const [state, setState] = React.useState({
    formData: {
      id: "",
      name: "",
      type: "product",
    },
  });

  const handleChange = (event) => {
    const { formData } = state;
    formData[event.target.name] = event.target.value;
    setState({ formData });
  };

  const handleSubmit = (event) => {
    confirm("Submit", "Are you sure to Submit ?").then(async (onProcess) => {
      if (props.data === null) {
        const { formData } = state;
        await categoryActions.store(formData);
        handleCloseDialog();
        cancel();
      } else {
        const { formData } = state;
        await categoryActions.put(formData);
        handleCloseDialog();
        cancel();
      }
    });
  };

  React.useEffect(() => {
    var query = {
      num: "10",
      cursor: "",
      position: "",
      search: "",
      type: "product",
    };
    categoryActions.get(query);
    if (data) {
      setState({
        formData: {
          id: data.id,
          name: data.name,
          type: "product",
        },
      });
    }
  }, [componentWillMount, categoryActions, data]);

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  return (
    <CustomizedDialogs
      maxWidth={width !== "xs" ? "md" : false}
      fullScreen={width === "xs"}
      title={props.title}
      open={openDialog}
      handleClose={handleCloseDialog}
    >
      <DialogContent dividers>
        <ValidatorForm
          id="myform"
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <Grid container justify="center">
            <Grid container justify="center" item xs={width === "lg" ? 8 : 12}>
              <Typography
                variant="subtitle1"
                className={classes.header}
                gutterBottom
              >
                Please Input Shopfront Category Management:
              </Typography>

              <Grid container item xs={11}>
                <TextValidator
                  id="name"
                  label="Name"
                  name="name"
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  value={state.formData.name}
                  validators={["required"]}
                  errorMessages={["Name is required"]}
                  onChange={handleChange}
                  autoFocus
                />
              </Grid>
            </Grid>
          </Grid>
        </ValidatorForm>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            handleCloseDialog();
          }}
          color="primary"
        >
          Cancel
        </Button>
        <Button
          type="submit"
          form="myform"
          variant="contained"
          style={{ marginRight: 30 }}
          color="primary"
        >
          Submit
        </Button>
      </DialogActions>
    </CustomizedDialogs>
  );
}

Form.propTypes = {
  width: PropTypes.oneOf(["lg", "md", "sm", "xl", "xs"]).isRequired,
  cancel: PropTypes.func,
};
export function submitFormProduct(title, data, options = {}) {
  return createConfirmation(confirmable(withStyles(styles)(withWidth()(Form))))(
    {
      title,
      data,
      ...options,
    }
  );
}
